// extracted by mini-css-extract-plugin
module.exports = {"payWrapper":"payWrapper___10Cv2","payBtns":"payBtns___gjI6H","btn":"btn___2T1wm","orderBtn":"orderBtn___1Yl2V"};